export const USER_LOGIN_SUCCESS= 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_LOADING = 'USER_LOGIN_LOADING';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_LOGIN_COMPLETE = 'USER_LOGIN_COMPLETE';



